<template>
  <v-navigation-drawer color="primary" expand-on-hover rail v-if="getLogged">
    <v-list nav dense>
      <v-list>
        <v-list-item></v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list-item
        link
        :to="menuItem.to"
        v-for="menuItem in menuItems"
        :key="menuItem.title"
        :prepend-icon="menuItem.icon"
        :title="menuItem.title"
      >
      </v-list-item>
      <v-spacer></v-spacer>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "MenuComponent",
  data: () => {
    return {
      showMenu: false,
      menuItems: [
        {
          to: "/videos",
          title: "Videos",
          icon: "mdi-video",
        },
        {
          to: "/unidades",
          title: "Unidades",
          icon: "mdi-office-building",
        },
        {
          to: "/unidadevideo",
          title: "Unidade video",
          icon: "mdi-group",
        },
        {
          to: "/realtime",
          title: "Tempo real",
          icon: "mdi-cube-scan",
        },
        {
          to: "/redirecionamentos",
          title: "Redirecionamentos",
          icon: "mdi-send-outline",
        },
        {
          to: "/repredi",
          title: "Rel. Redirecionamentos",
          icon: "mdi-chart-bar",
        },
        {
          to: "/usuarios",
          title: "Usuários",
          icon: "mdi-account-circle",
        },
        {
          to: "/logout",
          title: "Logout",
          icon: "mdi-exit-to-app",
        },
      ],
    };
  },
  methods: {},
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["getLogged"]),
  },

  watch: {},
};
</script>

<style>
</style>